import React, { useState, useEffect } from 'react'
import { createForm } from 'rc-form'
import {
  List,
  InputItem,
  TextareaItem,
  Picker,
  DatePicker,
  Toast,
  Flex,
  WhiteSpace,
  Icon
} from 'antd-mobile'
import UploadPicture from './components/UploadPicture'
import CommonModal from '@feedback/components/CommonModal'
import { useRequest } from 'ahooks'
import { getFeedbackConfig, submitFeedbackForm } from '@feedback/services/index'
import qs from 'qs'
import { getTextByKey, getTimeFormat } from '@feedback/utils/util'
import './App.scss'
import moment from 'moment'
import * as _ from 'lodash'
import { getAppConfig } from '@feedback/utils/CONST'

interface Props {
  form: any
  history: {
    location: {
      search: string
    }
    replace: any
  }
}
// 自定义表单页面
const handlePickerData = (arr: any[]) => {
  const tarArr: any[] = []
  for (const key in arr) {
    tarArr.push({ value: arr[key], label: arr[key] })
  }
  return tarArr
}

const App: React.FC<Props> = ({ form, history }) => {
  const { appid } = getAppConfig() || {}
  const headerFromApp = JSON.parse(
    sessionStorage.getItem('headerFromApp') || '{}'
  )

  const feedback_type: any = qs.parse(history.location.search.split('?')[1])
    .feedback_type
  const feedback_type_str: any = qs.parse(history.location.search.split('?')[1])
    .feedback_type_str
  const [isShowModal, toggleShowModal] = useState<boolean>(false) // 关闭问题弹窗
  const { getFieldDecorator, getFieldValue } = form
  const { data: formConfig, loading } = useRequest(() =>
    getFeedbackConfig({ question_id: feedback_type })
  )
  const { run: submitForm, loading: submitLoading } = useRequest(
    submitFeedbackForm,
    {
      manual: true,
      onSuccess: (result) => {
        const { code, message } = result
        if (code === 0) {
          toggleShowModal(true)
        } else {
          Toast.info(message, 2)
        }
      }
    }
  )
  const _onSubmit = () => {
    form.validateFields((err: any, values: any) => {
      if (err) {
        Toast.info(err[Object.keys(err)[0]].errors[0].message, 2)
        return false
      }
      const tarVal: any = {}
      tarVal.question_id = values.question_id // 有个落单的，问题分类配置里没这个。所以需要额外加
      formConfig.data.forEach((item: any) => {
        let valueItem = values[item.key]
        if (item.type === 3 && valueItem) {
          const date = new Date(valueItem)
          valueItem = `${date.getFullYear()}-${
            date.getMonth() + 1
          }-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`
        }
        // 字段包含key开头的时候是自定义字段。然后要特殊处理
        if (item.key.indexOf('key') !== -1) {
          tarVal[item.key] = {
            type: item.type,
            data: valueItem,
            name: item.name
          }
        } else {
          tarVal[item.key] = valueItem
        }
      })
      submitForm(tarVal)
    })
  }
  const closeShowModal = () => {
    toggleShowModal(false)
    setTimeout(() => {
      history.replace('/v1/ticketList')
    }, 0)
  }
  const confirmModal = () => {
    closeShowModal()
    setTimeout(() => {
      history.replace('/v1/ticketList')
    }, 0)
  }
  useEffect(() => {
    if (['cm1009', 'cm1017'].includes(appid) && headerFromApp?.language?.includes('fr')) {
      document.title = getTextByKey('cm1009.fr.feedback')
    } else {
      document.title = getTextByKey('feedback')
    }
  }, [])

  return (
    <div className='p-ticket-form'>
      <p className='form-tip'>{getTextByKey('feedback tip')}</p>
      <div className='ticket-form'>
        {loading && (
          <WhiteSpace>
            <Flex justify='center'>
              <Icon type='loading' color='#fff' />
            </Flex>
          </WhiteSpace>
        )}
        <div className='form-item'>
          <List
            renderHeader={() => (
              <b className={`item-title required`}>
                {getTextByKey('question type')}
              </b>
            )}
          >
            {getFieldDecorator('question_id', {
              initialValue: feedback_type
            })(
              <div className='form-item-feedback-type'>{feedback_type_str}</div>
            )}
          </List>
        </div>
        {/* 完整表单参数 */}
        {formConfig?.code === 0 && Array.isArray(formConfig.data)
          ? formConfig.data.map((item: any) => {
              if (item.type === 1) {
                // 文字输入框
                return item.line <= 1 ? (
                  <div className='form-item' key={item.key}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator(item.key, {
                        initialValue: '',
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name} is required`
                          }
                        ]
                      })(
                        <InputItem
                          maxLength={item.limit || 99999}
                          extra={
                            <div className='input-count'>{`${
                              getFieldValue(item.key).length
                            }/${item.limit || 99999}`}</div>
                          }
                        />
                      )}
                    </List>
                  </div>
                ) : (
                  <div className='form-item' key={item.name}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator(item.key, {
                        initialValue: '',
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(
                        <TextareaItem
                          count={parseInt(item.limit) || 99999}
                          // count={300}
                          rows={5}
                        />
                      )}
                    </List>
                  </div>
                )
              } else if (item.type === 2) {
                return (
                  <div className='form-item' key={item.key}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator(item.key, {
                        initialValue: 0,
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(
                        <InputItem
                          maxLength={item.limit || 99999}
                          type='money'
                        />
                      )}
                    </List>
                  </div>
                )
              } else if (item.type === 3) {
                // 日期选择
                return (
                  <div className='form-item form-picker-item' key={item.name}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator(item.key, {
                        initialValue: '',
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(
                        <DatePicker
                          extra=' '
                          format={(value: Date) => getTimeFormat(value)}
                        >
                          <List.Item arrow='down'></List.Item>
                        </DatePicker>
                      )}
                    </List>
                  </div>
                )
              } else if (item.type === 4) {
                // 图片
                return (
                  <div className='form-item form-picture-item' key={item.name}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      <UploadPicture form={form} formKey={item.key} />
                      {getFieldDecorator(item.key, {
                        initialValue: '',
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(<InputItem />)}
                    </List>
                  </div>
                )
              } else if (item.type === 5) {
                // 邮箱
                return (
                  <div className='form-item' key={item.key}>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator('email', {
                        initialValue: '',
                        rules: [
                          {
                            required: item.is_must === 1,
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(<InputItem />)}
                    </List>
                  </div>
                )
              } else if (item.type === 6) {
                // 选择
                const pickerData = handlePickerData(item.select)
                return (
                  <div className='form-item'>
                    <List
                      renderHeader={() => (
                        <b
                          className={`item-title ${
                            item.is_must === 1 ? 'required' : ''
                          }`}
                        >
                          {item.name}
                        </b>
                      )}
                    >
                      {getFieldDecorator(item.key, {
                        initialValue: [],
                        rules: [
                          {
                            required: true,
                            type: 'array',
                            message: `${item.name}!!!!`
                          }
                        ]
                      })(
                        <Picker
                          data={pickerData}
                          cols={1}
                          okText={getTextByKey('confirm')}
                          dismissText={getTextByKey('cancel')}
                        >
                          <div className='picker-value'>
                            {getFieldValue(item.key)[0]}&nbsp;
                          </div>
                        </Picker>
                      )}
                    </List>
                  </div>
                )
              } else {
                return null
              }
            })
          : null}
        <div className='form-item'>
          {Array.isArray(formConfig?.data) && (
            <div className='btn-submit' onClick={_.debounce(_onSubmit, 1000)}>
              {/* 这里要限制提交次数,1s只能点击一次 */}
              <span className='btn-text'>{getTextByKey('submit')}</span>
            </div>
          )}
        </div>
      </div>
      {isShowModal && (
        <CommonModal
          title={getTextByKey('notification')}
          desc={getTextByKey('submit modal tip')}
          tip=''
          confirmText={getTextByKey('confirm')}
          confirmFun={confirmModal}
          closeFun={closeShowModal}
        />
      )}
    </div>
    // Working hours:  09:30~18:00
  )
}

export default createForm()(App)
